export default "__VITE_ASSET__DIw1n36k__"